export const productData = []

export const shopWideData = []

export const filterData = [
    {
        title: "RECENT STORIES",
        key: "recent-stories"
    },
    {
        title: "SPECIALE STORIES",
        key: "special-stories"
    },
]

export const onlyCategoriesData = []

export const FashionShopData = []